import React from "react";
import { useLocation } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { MobileBottomNav } from "@/components/MobileBottomNav";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAuth } from "@/contexts/AuthContext";
import { FeedbackDrawer } from "@/components/FeedbackDrawer";

const PUBLIC_PATHS = ["/", "/auth", "/pricing", "/subscribe", "/shared/deck", "/shared/sheet", "/shared/quiz", "/shared/case", "/blog", "/calculateurs", "/calculateur", "/cgu", "/privacy", "/mentions-legales", "/legal", "/admin", "/articles", "/features", "/a-propos"];

export function AppLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const isMobile = useIsMobile();
  const { user } = useAuth();

  const isPublicPage = PUBLIC_PATHS.some(
    (p) => location.pathname === p || location.pathname.startsWith(p + "/")
  ) || location.pathname.startsWith("/profil/");

  // No sidebar/nav on public pages or when not logged in
  if (isPublicPage || !user) {
    return (
      <>
        <main id="main-content" className="pb-safe-bottom">
          {children}
        </main>
        {user && <FeedbackDrawer />}
      </>
    );
  }

  // Mobile: no sidebar, just bottom nav
  if (isMobile) {
    return (
      <>
        <main id="main-content" style={{ paddingBottom: 'calc(4rem + env(safe-area-inset-bottom) + 8px)' }}>
          {children}
        </main>
        <MobileBottomNav />
        <FeedbackDrawer />
      </>
    );
  }

  // Desktop: sidebar layout
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <main id="main-content" className="flex-1 min-w-0">
          {children}
        </main>
      </div>
      <FeedbackDrawer />
    </SidebarProvider>
  );
}
